<div class="mx-2 mb-2 p-1 border rounded border-solid border-gray-300 dark:border-gray-500 uppercase font-semibold text-base text-center text-gray-500 dark:text-gray-200">

    <div class="my-20">
        <img aria-hidden="true" class="mx-auto h-64 w-auto dark:hidden" src="/assets/images/construccion-light.svg" alt="SOGAK"/>
        <img aria-hidden="true" class="hidden mx-auto h-64 w-auto dark:block" src="/assets/images/construccion-dark.svg" alt="SOGAK"/>
    </div>

</div>
